import { ShoppingCartOutlined ,AppstoreAddOutlined, FileImageOutlined, HistoryOutlined, PlusOutlined, ProductOutlined, SettingOutlined, TagOutlined, UserOutlined } from '@ant-design/icons';
import { TfiLocationPin } from 'react-icons/tfi';
export const topMenuItems = [
  // {
  //   label: 'Самбар',
  //   key: 'dashboard',
  //   icon: <SettingOutlined />,
  // },
  {
    label: 'Салбар',
    key: 'settings',
    icon: <SettingOutlined />,
    children: [
      { label: 'Салбар', key: 'stores-settings' },
      { label: 'Хуваарь', key: 'schedule-settings' },
      { label: 'Под', key: 'pod-settings' },
      { label: 'Салбар шалгах', key: 'pos-check' },
    ],
  },
  {
    label: 'Хаяг',
    key: 'address',
    icon: <TfiLocationPin size={16} />,
    children: [
      { label: 'Хаяг засах', key: 'edit-address' },
      { label: 'Байршил засах', key: 'edit-location' },
      { label: 'Байршлаар хайх', key: 'search-location' },
    ],
  },
  {
    label: 'Хямдрал',
    key: 'discount',
    icon: <ShoppingCartOutlined />
  },
  {
    label: "Бүтээгдэхүүн удирдлага",
    key: 'product',
    icon: <ProductOutlined />,
    children: [
      {
        label: 'Tags',
        key: 'tags',
        icon: <TagOutlined />
      },
      {
        label: 'Modifiers',
        key: 'modifiers',
        icon: <PlusOutlined />
      },
      {
        label: 'Deals',
        key: 'deals',
        icon: <AppstoreAddOutlined />
      },
      {
        label: 'Бүтээгдэхүүн', 
        key: 'list-product', 
        icon: <ProductOutlined /> 
      },
      { label: 'Зураг', key: 'product-images', icon: <FileImageOutlined /> },
      { label: 'Audit logs', key: 'audit-logs', icon: <HistoryOutlined /> },
    ]
  },
  // {
  //   label: 'Хуучин цэс',
  //   key: 'menus',
  //   icon: <SettingOutlined />,
  //   children: [
  //     { label: 'Бүх меню татах', key: 'getmenuAllStore' },
  //     { label: 'Бүтээгдэхүүн', key: 'list' },
  //     { label: 'Багц меню', key: 'combo' },
  //     { label: 'Багц хуулах', key: 'copyCombo' },
  //     { label: 'Орчуулга', key: 'translate' },
  //     { label: 'Лог', key: 'log' },
  //     { label: 'Зураг', key: 'images' },
  //     { label: 'Бүтээгдэхүүн нуух', key: 'product-visibility' },
  //     { label: 'Бүтээгдэхүүн тохиргоо', key: 'product-settings' },
  //     { label: 'Бүтээгдэхүүний хуулах', key: 'product-copy' },
  //   ],
  // },
  {
    label: 'Хэрэглэгч',
    key: 'users',
    icon: <SettingOutlined />,
    children: [
      { label: 'Хэрэглэгч хайх', key: 'search-user' },
      { label: 'Бүх хэрэглэгч', key: 'users' },
    ],
  },
  {
    label: 'Profile',
    key: 'profile1',
    icon: <UserOutlined />,
    children: [
      { label: 'Мэдээлэл', key: 'profile' },
      { label: 'Гарах', key: 'logout' },
    ],
  }
];
export const bottomMenuItems = [
  {
    label: 'Profile',
    key: 'settings',
    icon: <UserOutlined />,
    children: [
      { label: 'Мэдээлэл', key: 'profile' },
      { label: 'Гарах', key: 'logout' },
    ],
  },
];
